function hiddenLink(){
    document.querySelectorAll('.hidden-link').forEach(hiddenLink => {
        const link = document.createElement('a');
        link.href = hiddenLink.dataset.link;
        link.target = '_blank';
        link.innerHTML = hiddenLink.innerHTML;
        hiddenLink.replaceWith(link);
    });
}
export default hiddenLink;